__turbopack_context__.v({
  "avatar": "reviews-module-scss-module__0ezz8G__avatar",
  "content": "reviews-module-scss-module__0ezz8G__content",
  "date": "reviews-module-scss-module__0ezz8G__date",
  "descriptions": "reviews-module-scss-module__0ezz8G__descriptions",
  "details": "reviews-module-scss-module__0ezz8G__details",
  "grid": "reviews-module-scss-module__0ezz8G__grid",
  "loader": "reviews-module-scss-module__0ezz8G__loader",
  "name": "reviews-module-scss-module__0ezz8G__name",
  "review": "reviews-module-scss-module__0ezz8G__review",
  "starWrapper": "reviews-module-scss-module__0ezz8G__starWrapper",
  "wrapper": "reviews-module-scss-module__0ezz8G__wrapper",
});
